<template>
  <div class="page">
    <div class="searchBox">
      <el-form>
        <el-row>
          <el-col :span="5">
            <el-form-item>
              <el-input
                style="width: 200px; margin-right: 10px"
                placeholder="订单号|用户|芯片|脖圈"
                v-model="search.keyword"
                @keyup.enter.native="changeSearch"
              ></el-input>
              <el-button
                @click="changeSearch"
                icon="el-icon-search"
                type="warning"
                >搜索</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="状态" :label-width="'80px'">
              <el-select
                style="width: 110px"
                class="select"
                v-model="search.state"
                @change="changeSearch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in [
                    { label: '全部', value: -1 },
                    { label: '已申请', value: 1 },
                    { label: '审核中', value: 2 },
                    { label: '处理成功', value: 3 },
                    { label: '已取消', value: -2 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="欠宠状态" :label-width="'80px'">
              <el-select
                style="width: 110px"
                class="select"
                v-model="search.owe_pet_state"
                @change="changeSearch"
                placeholder="请选择"
              >
  
                <el-option
                  v-for="item in [
                    { label: '全部', value: -1 },
                    { label: '无欠宠', value: 0 },
                    { label: '欠宠中', value: 1 },
                    { label: '换宠中', value: 2 },
                    { label: '已完成', value: 3 },
                    { label: '已退款', value: 4 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="类型" :label-width="'200px'">
              <el-select
                style="width: 110px"
                class="select"
                v-model="type"
                @change="changeSearch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in [
                    { label: '全部', value: -1 },
                    { label: '退宠', value: 1 },
                    { label: '换宠', value: 2 },
                    { label: '欠宠', value: 3 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="退货日期" :label-width="'90px'">
              <el-date-picker
                @change="changeSearch"
                v-model="datetimerange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                style="width: 200px"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <resetBtn @reset="reset"></resetBtn>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="pageConBox">
      <el-table :data="tableData" style="width: 100%" fit>
        <el-table-column
          prop="create.operation_user.user_name"
          label="创建人"
        ></el-table-column>
        <el-table-column prop="create.operation_time" label="创建日期">
          <template slot-scope="scope">
            {{
              scope.row.create
                ? $public.FTime(scope.row.create.operation_time)
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="订单编号"
          prop="return_pet.order_no"
        ></el-table-column>
        <el-table-column
          label="顾客"
          prop="user_info.nick_name"
        ></el-table-column>
        <el-table-column
          label="宠物"
          prop="return_pet.pet_name"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="退换说明"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              width="300"
              trigger="hover"
              :disabled="scope.row.remark.length <= 15"
            >
              <div>{{ scope.row.remark }}</div>
              <span slot="reference" v-if="scope.row.remark.length <= 15">{{
                scope.row.remark
              }}</span>
              <span slot="reference" v-if="scope.row.remark.length > 15">{{
                scope.row.remark.substr(0, 15) + "..."
              }}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型">
          <!-- 1 退宠 2 换宠 3 欠宠 -->
          <template slot-scope="scope">
            {{ scope.row.type == "1" ? "退宠" : "" }}
            {{ scope.row.type == "2" ? "换宠" : "" }}
            {{ scope.row.type == "3" ? "欠宠" : "" }}
          </template>
        </el-table-column>
        <el-table-column prop="owe_pet_state" label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.type == '3'">
              {{ $public.formatoweState(scope.row.owe_pet_state) }}--{{
                $public.formatState(scope.row.state)
              }}
            </div>
            <div v-else>
              {{ $public.formatState(scope.row.state) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="
                $router.push({
                  path: '/arrearsOrder/arrearsOrderSee',
                  query: { id: scope.row._id },
                })
              "
              >查看</el-button
            >
            <el-button
              v-show="scope.row.owe_pet_state == '1'&&scope.row.state=='3'"
              type="text"
              size="small"
              @click="refund(scope.row)"
              >退款</el-button
            >
            <el-button
              v-show="scope.row.owe_pet_state == '1'&&scope.row.state=='3'"
              type="text"
              size="small"
              @click="change(scope.row)"
              >换宠</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <page :total="page.total" :page="page.page" @change="changePage"></page>
    </div>
    <!-- 退款 -->
    <div v-if="drawerSeeProduct_state">
      <drawerSeeProduct :tabInfo="tabInfo" @submit="tuiKuan"></drawerSeeProduct>
    </div>
    <!-- 换宠弹框exchange -->
    <div v-if="drawerChange_state">
      <drawerChange @submit="huanChong" :tabInfo="tabInfo"></drawerChange>
    </div>
  </div>
</template>
<script>
import page from "../../../../components/page.vue";
import resetBtn from "../../../../components/resetBtn.vue";
import drawerSeeProduct from "./drawer_seeProduct.vue";
import drawerChange from "./drawer_Change.vue";
export default {
  components: { page, resetBtn, drawerSeeProduct, drawerChange },
  data() {
    return {
      drawerSeeProduct_state: false,
      drawerChange_state: false,
      search: {
        keyword: "",
        state: -1, // 状态 状态  -1全部 1 已申请 2 审核中 3 处理成功 -2 已取消 -1 审核失败
        owe_pet_state:-1,
      },
      type: -1, //-1全部 1 退宠 2 换宠 3 欠宠
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      tabInfo: {},
      datetimerange: [],
    };
  },
  computed: {
    curShopId() {
      return this.$store.state.shopId;
    },
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    //换宠
    huanChong() {
      this.drawerChange_state = false;
      this.getTableData();
    },
    // 退款
    tuiKuan() {
      this.drawerSeeProduct_state = false;
      this.getTableData();
    },
    // 换宠
    change(row) {
      this.tabInfo = row;
      this.drawerChange_state = true;
    },
    //欠宠退款
    refund(row) {
      this.tabInfo = row;
      this.drawerSeeProduct_state = true;
    },
    reset() {
      this.page.page = 1;
      this.search.keyword = "";
      this.search.starttime = "";
      this.search.endtime = "";
      this.datetimerange = [];
      this.search.state = -1;
      this.search.owe_pet_state = -1;
      
      this.search.pay_type = -1;
      this.getTableData();
    },
    changeSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    // 改变分页
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    // 获取列表数据
    getTableData() {
      let loading = this.$loading();

      let params = {
        type: this.type - 0, //-1全部 1 退宠 2 换宠 3 欠宠
        "owe_pet_state": this.search.owe_pet_state,//0 无欠宠 1 欠宠中 2 换宠中 3 已完成 4 已退款
        state: this.search.state, // 状态  -1全部 1 已申请 2 审核中 3 处理成功 -2 已取消 -1 审核失败
        // "state": -1,
        keyword: this.search.keyword,
        // "user_id": this.$store.state.userInfo.uid,   // 用户id
        shop_id: this.$store.state.shopId, // 门店id
        page_index: this.page.page,
        page_size: this.page.pageSize,
      };
      if (this.datetimerange && this.datetimerange.length == 2) {
        params.beginTime = this.$public.FTimeStr10(this.datetimerange[0]);
        params.endTime = this.$public.FTimeStr10(this.datetimerange[1]);
      }
      console.log(params);
      this.$http
        .post(
          process.env.VUE_APP_Url_order + "/api/PetReplaceRecord/getlist",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.tableData = res.data.data;
            console.log("1111111", this.tableData);
            this.page.total = res.data.count;
          }
        });
    },
    // 筛选订单包含的宠物
    getPetList(list) {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i].pets_info) {
          if (
            arr.indexOf(
              list[i].pets_info.pets_name + "bind" + list[i].pets_info.pets_id
            ) === -1
          ) {
            arr.push(
              list[i].pets_info.pets_name + "bind" + list[i].pets_info.pets_id
            );
          }
        }
      }
      return arr;
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  .searchBox {
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .pageConBox {
    padding: 0 20px;
    min-height: 600px;
  }
}
</style>
